import { GlobeIcon, MoonIcon, SunIcon } from '@/components/icons'
import { HeaderMenu, MenuOption } from '@/features/nav/menu'
import type { System } from '@/lib/auth-store'
import { LANGUAGES, LANGUAGE_NAMES } from '@/lib/i18n/languages'
import { chooseLanguage, useLanguage } from '@/lib/i18n/store'
import { useT } from '@/lib/i18n/translate'
import { THEME_PREFERENCES, setThemePreference, useTheme, useThemePreference } from '@/lib/theme'

/** Header language picker; with `system`, a logged-in choice also becomes the account preference (T4.7). */
export function LanguageMenu({ system }: { system?: System | undefined }) {
  const t = useT()
  const language = useLanguage()
  return (
    <HeaderMenu label={t('language.label')} icon={<GlobeIcon />}>
      {(close) =>
        LANGUAGES.map((lang) => (
          <MenuOption
            key={lang}
            selected={lang === language}
            onClick={() => {
              close()
              // Local switch applies at once; the account save is best-effort here.
              void chooseLanguage(lang, system).catch(() => {})
            }}
          >
            {LANGUAGE_NAMES[lang]}
          </MenuOption>
        ))
      }
    </HeaderMenu>
  )
}

/** Header theme picker; the trigger shows the theme in effect, per device (not per account). */
export function ThemeMenu() {
  const t = useT()
  const preference = useThemePreference()
  const theme = useTheme()
  return (
    <HeaderMenu label={t('theme.label')} icon={theme === 'dark' ? <MoonIcon /> : <SunIcon />}>
      {(close) =>
        THEME_PREFERENCES.map((option) => (
          <MenuOption
            key={option}
            selected={option === preference}
            onClick={() => {
              close()
              setThemePreference(option)
            }}
          >
            {t(`theme.${option}`)}
          </MenuOption>
        ))
      }
    </HeaderMenu>
  )
}
